"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// scripts
require("./DatetimePickerDirective");
require("./MenuToolbarDirective");
require("./NotifyDirective");
require("./ListControlDirective");
require("./PaginationDirective");
exports.default = angular.module('profumo.core.directives', [
    'profumo.core.directives.datetime-picker',
    'profumo.core.directives.menu-toolbar',
    'profumo.core.directives.notify',
    'profumo.core.directives.list-control',
    'profumo.core.directives.pagination'
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/index.ts
// module id = 456
// module chunks = 0